
import { get, getById } from "@/utilities/querySelector";
import { toggleScroll } from "@/utilities/toggleScroll";


const header = document.getElementById( 'site-header' );
const mobileMenuToggle = document.getElementById( 'mobile-menu-toggle' );
const mobileMenu = document.getElementById( 'mobile-menu' );

const logoWrap = get( '.site-header__logo-wrap' );
const mainLogo = getById( 'site-main-logo' );
const scrolledLogo = getById( 'site-scrolled-logo' );


mobileMenuToggle?.addEventListener( 'click', () => {
    toggleMenu( 'mobile' );
} );

mobileMenu?.querySelectorAll( 'a' ).forEach( link => {
    link.addEventListener( 'click', () => {
        closeMenus();
    } );
} );


/**
 * @param {string} menu Then menus name
 *
 * @return void
 */
function toggleMenu( menu ) {
    if ( header?.getAttribute( 'data-menu-active' ) === menu ) {
        closeMenus();
    } else {
        openMenu( menu );
    }
}

/**
 * Opens the specified header menu
 *
 * @param {string} menu
 *
 * @return void
 */
function openMenu( menu ) {
    header?.setAttribute( 'data-menu-active', menu );
    toggleScroll( false );
}

/**
 * Closes all the header menus
 *
 * @return void
 */
function closeMenus() {
    header?.removeAttribute( 'data-menu-active' );
    toggleScroll( true );
}

/*
Using intersection observer is way more efficient than adding a scroll listener for this task
*/
const scrollIndicator = document.getElementById( 'site-header-scroll-indicator' );
if ( header && scrollIndicator ) {
    const scrollDeterminer = new IntersectionObserver( headerScrollHandler, {} );
    scrollDeterminer.observe( scrollIndicator );
}

/**
 * @param {IntersectionObserverEntry[]} entries
 *
 * @return void
 */
function headerScrollHandler( entries ) {
    entries.forEach( entry => {
        if ( !entry.isIntersecting ) {
            header?.setAttribute( 'data-scrolled', '' );
            logoWrap.style.height = scrolledLogo.clientHeight + 'px';
        } else {
            header?.removeAttribute( 'data-scrolled' );
            logoWrap.style.height = mainLogo.clientHeight + 'px';
        }
    } );
}

